import React from "react";
import { Link } from "react-router-dom";
import {
  HiOutlineLockClosed,
  HiOutlineArrowLeft,
  HiOutlineShieldExclamation,
  HiOutlineExclamation,
} from "react-icons/hi";

const Forbidden = () => {
  return (
    <div className="min-h-screen bg-[#0b0e14] flex flex-col items-center justify-center p-4 selection:bg-red-500/30 relative overflow-hidden">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-red-600/5 rounded-full blur-[160px] pointer-events-none animate-pulse" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-purple-600/5 rounded-full blur-[160px] pointer-events-none" />

      {/* Scanline Effect */}
      <div className="absolute inset-0 bg-[linear-gradient(transparent_50%,rgba(0,0,0,0.1)_50%)] bg-[length:100%_4px] pointer-events-none opacity-20" />

      <div className="max-w-xl w-full text-center relative z-10">
        {/* Alert Icon */}
        <div className="relative inline-block mb-10">
          <div className="absolute inset-0 bg-red-500/20 blur-3xl rounded-full animate-pulse" />
          <div className="relative w-32 h-32 bg-red-500/10 border-2 border-red-500/30 rounded-[2rem] flex items-center justify-center mx-auto">
            <HiOutlineLockClosed className="text-6xl text-red-500 animate-pulse" />
          </div>
          {/* Floating Warning Icons */}
          <div className="absolute -top-2 -right-2 w-10 h-10 bg-amber-500/20 border border-amber-500/30 rounded-xl flex items-center justify-center text-amber-500 animate-bounce">
            <HiOutlineExclamation className="text-xl" />
          </div>
        </div>

        {/* Error Code Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-500/10 border border-red-500/20 rounded-full text-[10px] font-black text-red-400 uppercase tracking-[0.3em] mb-6">
          <span className="w-2 h-2 bg-red-500 rounded-full animate-ping" />
          Error_Code: 403_FORBIDDEN
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-white uppercase italic tracking-tighter mb-6">
          Access <span className="text-red-500">Denied</span>
        </h1>

        <div className="bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[2rem] p-8 mb-10 relative overflow-hidden">
          {/* Warning Stripe */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500/0 via-red-500 to-red-500/0" />

          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-red-500/10 border border-red-500/20 rounded-xl flex items-center justify-center text-red-400">
              <HiOutlineShieldExclamation className="text-2xl" />
            </div>
            <div className="text-left">
              <h3 className="text-sm font-black text-white uppercase tracking-widest italic">
                Security Alert
              </h3>
              <p className="text-[10px] font-bold text-gray-500 uppercase tracking-widest">
                Clearance Level Insufficient
              </p>
            </div>
          </div>

          <p className="text-gray-400 font-medium leading-relaxed text-sm">
            The coordinate you are attempting to reach is restricted to{" "}
            <span className="text-red-400 font-black">
              executive administrators
            </span>{" "}
            only. Your current security clearance does not permit access to this
            sector. This incident has been logged.
          </p>
        </div>

        <div className="space-y-4">
          <Link
            to="/"
            className="group relative flex items-center justify-center gap-3 w-full p-5 bg-white text-black font-black rounded-2xl hover:invert transition-all duration-300 shadow-2xl shadow-cyan-500/10 uppercase tracking-[0.2em] italic text-[11px] overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700" />
            <HiOutlineArrowLeft className="text-xl group-hover:-translate-x-1 transition-transform" />
            <span className="relative">Return_To_Safety</span>
          </Link>

          <Link
            to="/contact"
            className="flex items-center justify-center gap-3 w-full p-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-cyan-500/30 text-gray-400 hover:text-cyan-400 font-black rounded-2xl transition-all uppercase tracking-[0.2em] italic text-[10px]"
          >
            Request_Clearance_Upgrade
          </Link>
        </div>

        {/* System Info Footer */}
        <div className="mt-12 flex items-center justify-center gap-4 text-[9px] text-gray-600 font-black uppercase tracking-[0.3em]">
          <span>GamerHub Security Protocol</span>
          <span className="w-1 h-1 bg-gray-700 rounded-full" />
          <span>v2.4.1</span>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
